import { render, staticRenderFns } from "./PassSidebar.vue?vue&type=template&id=f9be451a&scoped=true&"
import script from "./PassSidebar.vue?vue&type=script&lang=js&"
export * from "./PassSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PassSidebar.vue?vue&type=style&index=0&id=f9be451a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9be451a",
  null
  
)

export default component.exports